import React from "react";
import styled from "styled-components";
import {Cell, Table, Td, Th, Tr} from "../../elements/Tables";
import PerformanceValue from "../../performance/PerformanceValue";
import Kpi, {kpiBriefDescription} from "../../performance/Kpi";
import GroupNameCell from "./GroupNameCell";
import {NegativeValue, PositiveValue} from "../../performance/StyledValue";

export const GroupingRankCell = styled(Cell)`
    font-weight: bold;
`;

export const GroupingNewIdeas = ({children}) => <Cell right>{children}</Cell>;

export const GroupingKpiValue = ({name, value}) => <Cell right><PerformanceValue name={name} value={value}/></Cell>;

const TrClickable = styled(Tr)``;

const StyledGroupingTable = styled(Table)`
    ${TrClickable}:hover ${PositiveValue},
    ${TrClickable}:hover ${NegativeValue} {
        color: white;
    }
`;

const GroupingTable = ({selectedKpi, grouping, currency, showRank, rowLinkGenerator}) => {
    const groupNameCell = (row) => (<GroupNameCell groupName={row.groupName}
                                                   groupClarifier={row.groupClarifier}/>);
    const kpiHeader = selectedKpi.matchesConfiguredKpi ? <Kpi>KPI</Kpi> : kpiBriefDescription(selectedKpi.name, currency);
    return (
        <StyledGroupingTable>
            <thead>
            <Tr>
                {showRank ? <Th><Cell right>Rank</Cell></Th> : null}
                <Th><Cell left>Name</Cell></Th>
                <Th><Cell right>New Ideas</Cell></Th>
                <Th><Cell right>{kpiHeader}</Cell></Th>
            </Tr>
            </thead>
            <tbody>
            {
                grouping.map((row, index) => {

                        const wrapWithLink = content => (rowLinkGenerator
                            ? rowLinkGenerator(row.groupKey, row.groupName, content)
                            : content);

                        const shouldBeClickable = (!!rowLinkGenerator && row.groupName !== "REDACTED");

                        const RowComponent = shouldBeClickable ? TrClickable : Tr;

                        return (<RowComponent key={index} clickable={shouldBeClickable}>
                            {showRank ?
                                <Td>
                                    {wrapWithLink(<GroupingRankCell right>{row.rank}</GroupingRankCell>)}
                                </Td> : null
                            }
                            <Td>
                                {wrapWithLink(groupNameCell(row))}
                            </Td>
                            <Td>
                                {wrapWithLink(<GroupingNewIdeas>{row.numberOfNewIdeas}</GroupingNewIdeas>)}
                            </Td>
                            <Td>
                                {wrapWithLink(<GroupingKpiValue name={selectedKpi.name} value={selectedKpi.valueFor(row)}/>)}
                            </Td>
                        </RowComponent>);
                    }
                )
            }
            </tbody>
        </StyledGroupingTable>
    );
};

export default GroupingTable;